import type { FastagProfile } from '../types';

export const fastagProfiles: Record<string, FastagProfile> = {
  unqualified: {
    linked: true,
    balance: 500,
    recommendedAmount: 0,
    recentDecline: false,
    predictedLow: false,
  },
  low: {
    linked: true,
    balance: 47,
    recommendedAmount: 200,
    recentDecline: false,
    predictedLow: false,
  },
  negative: {
    linked: true,
    balance: -32,
    recommendedAmount: 300,
    recentDecline: true,
    predictedLow: false,
  },
  'predicted-low': {
    linked: true,
    balance: 120,
    recommendedAmount: 200,
    recentDecline: false,
    predictedLow: true,
  },
};

export const defaultProfile = fastagProfiles.low;
